import { Card, Result, Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

export function BillingSuccess() {
  const navigate = useNavigate();

  return (
    <Card>
      <Result
        status="success"
        title="Payment method saved"
        subTitle={
          <Typography.Paragraph type="secondary" style={{ marginBottom: 0 }}>
            Your card is on file but <strong>you have not been charged yet</strong>. The 7-day
            free trial starts the moment you connect your first CREA DDF feed — and you can
            cancel from the Stripe customer portal any time before day 8.
          </Typography.Paragraph>
        }
        extra={[
          <Button type="primary" key="feeds" size="large" onClick={() => navigate('/feeds')}>
            Connect a feed
          </Button>,
          <Button key="billing" onClick={() => navigate('/billing')}>
            Back to billing
          </Button>,
        ]}
      />
    </Card>
  );
}
